import { Dialog } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { FileUploader } from "react-drag-drop-files";
import SearchIcon from '../../../assets/Header/SearchIcon';
import ArrowBack from '../../../assets/Modals/BackArrow';
import EmoteIcon from '../../../assets/Posts/EmoteIcon';
import { useAuth } from '../../../contexts/auth';
import { api } from '../../../services/api';
import Button from '../../Button';
import SnipzPlayer from '../../Feed/SnipzPlayer';
import InputLogin from '../../InputLogin';
import User from '../../User';
import { FollowText } from '../../User/styles';
import {
  AddImageButton,
  CloseModal,
  Container,
  ContentBottomContainer,
  ContentContainer,
  ContentTopContainer,
  DeleteButtonWrapper,
  DescriptionInput,
  EmoteIconWrapper,
  Header,
  Header2,
  HeaderIcon,
  HeaderText,
  ImageButton,
  ImageContainer,
  ImageWrapper,
  InfosContainer,
  InfosInnerContainer,
  InputBottomContainer,
  InputContainer,
  InputDescription,
  InputMiddleContainer,
  InputMiddleLine,
  InputMiddleText,
  InputTitle,
  InputTopContainer,
  LetterCounter,
  ProportionButton,
  ProportionInfo,
  ProportionsContainer,
  SelectorContainer,
  SelectorOption,
  SelectorText,
  Tag,
  TagsContainer,
  TagsTitle
} from './styles';

type PostModalProps = {
  open: boolean;
  onClose: (state: boolean) => void;
};

const imageFileTypes = ["jpg", "jpeg", "png"];
const videoFileTypes = ["mp4", "webm"];

export default function PublicationModal({ open, onClose }: PostModalProps) {
  const [step, setStep] = useState(0)
  const [files, setFiles] = useState<File[]>([])
  const [descriptions, setDescriptions] = useState<string[]>([])
  const [tags, setTags] = useState<string[]>([])
  const [selectedPostIndex, setSelectedPostIndex] = useState<number>(0)
  const [hasVideo, setHasVideo] = useState<boolean>(false)
  const videoRef = useRef<HTMLVideoElement>(null);
  const { user } = useAuth();

  const handleFiles = (newFiles: File[]) => {
    const filteredFiles = Array.from(newFiles).filter(file => {
      const fileExtension = file.name.split('.').pop()?.toLowerCase();
      return imageFileTypes.includes(fileExtension!) || videoFileTypes.includes(fileExtension!);
    });

    const containsVideo = filteredFiles.some(file => {
      const fileExtension = file.name.split('.').pop()?.toLowerCase();
      return videoFileTypes.includes(fileExtension!);
    });

    if (containsVideo) {
      const videoElement = videoRef.current || document.createElement('video');
      videoElement.preload = 'metadata';
      videoElement.src = URL.createObjectURL(filteredFiles[0]);

      videoElement.onloadedmetadata = () => {
        const duration = videoElement.duration;
        if (duration > 300) {
          alert('O vídeo deve ter no máximo 5 minutos');
          return;
        } else {
          setHasVideo(true)
          const firstVideoFile = filteredFiles.find(file => {
            const fileExtension = file.name.split('.').pop()?.toLowerCase();
            return videoFileTypes.includes(fileExtension!);
          });
          setFiles(firstVideoFile ? [firstVideoFile] : []);
          setDescriptions(['']);
        }
      };
    } else {
      setHasVideo(false)
      const existingFiles = files ? [...files] : [];
      const newImageFiles = filteredFiles.filter(file => {
        const fileExtension = file.name.split('.').pop()?.toLowerCase();
        return imageFileTypes.includes(fileExtension!);
      });

      const spaceForNewImages = 10 - existingFiles.length;
      const imagesToAdd = newImageFiles.slice(0, spaceForNewImages);

      setFiles([...existingFiles, ...imagesToAdd]);
      setDescriptions([...descriptions, ...new Array(imagesToAdd.length).fill('')]);
    }
  }

  useEffect(() => {
    if (files.length > 0) {
      setStep(1)
    }
  }, [files])

  const handleBack = () => {
    setFiles([])
    setDescriptions([''])
    setStep(0)
  }

  const handleDeleteImage = async (indexToRemove: number) => {
    if (indexToRemove === 0) return;
    const newFiles = files.filter((_, index) => index !== indexToRemove);
    setFiles(newFiles);
    descriptions.splice(indexToRemove, 1);
  }

  const handleDescriptionChange = (index: number, value: string) => {
    const newDescriptions = [...descriptions];
    newDescriptions[index] = value;
    if (newDescriptions[index].length > 2000) {
      newDescriptions[index] = newDescriptions[index].slice(0, 2000);
    }
    setDescriptions(newDescriptions);
  }

  const [tagInputValue, setTagInputValue] = useState('')
  const handleTags = (e: any) => {
    if (e === ' ' && tagInputValue !== '') {
      setTags(e.target.value.split(' '));
      setTagInputValue('');
    } else {
      setTagInputValue(e.target.value);
      setTags(e.target.value.split(' '))
    }
  }

  const handlePublish = async () => {
    let descriptionsNumber = 0;
    let filledDescriptionsIndex = 0;
    descriptions.forEach(description => {
      if (description !== '') {
        descriptionsNumber += 1;
        filledDescriptionsIndex = descriptions.indexOf(description);
      }
    });
    if (descriptionsNumber === 0) {
      alert('Preencha pelo menos uma descrição');
      return;
    } else if (descriptionsNumber === 1) {
      descriptions.forEach((description, index) => {
        if (index !== filledDescriptionsIndex) {
          descriptions[index] = descriptions[filledDescriptionsIndex];
        }
      });
    }

    let resizedFiles: any = [];
    if (!hasVideo) {
      try {
        resizedFiles = await Promise.all(files.map(async (file) => {
          return await getCroppedImg(file, file.name);
        }));
      } catch (err) {
        console.log(err);
      }
    } else {
      resizedFiles = files
    }

    if (resizedFiles && resizedFiles.length > 0) {
      const formData = new FormData();
      formData.append('type', postType);
      descriptions.forEach(description => {
        formData.append('description[]', description);
      });

      tags.forEach(tag => {
        formData.append('tags[]', tag);
      });

      resizedFiles.forEach((file: Blob) => {
        formData.append('medias', file);
      });

      // formData.append('medias', resizedFiles);
      await api.post('/media/create', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(response => {
          // console.log('media created', response.data);
        })
        .catch(error => {
          console.log(error);
        });
      onClose(false);
    }
  }

  type AdjustmentResult = {
    newWidth: number;
    newHeight: number;
    offsetX: number;
    offsetY: number;
  };

  function adjustDimensions(width: number, height: number): AdjustmentResult {
    const [aspectWidth, aspectHeight] = selectedProportion.split(':').map(Number);
    const targetRatio = aspectWidth / aspectHeight;

    let newWidth: number;
    let newHeight: number;
    let offsetX: number = 0;
    let offsetY: number = 0;

    const currentRatio = width / height;

    if (currentRatio > targetRatio) {
      newHeight = height;
      newWidth = Math.floor(height * targetRatio);
      offsetX = (width - newWidth) / 2;
    } else {
      newWidth = width;
      newHeight = Math.floor(width / targetRatio);
      offsetY = (height - newHeight) / 2;
    }

    return {
      newWidth,
      newHeight,
      offsetX,
      offsetY
    };
  }

  const [postType, setPostType] = useState('post')
  const [postTitle, setPostTitle] = useState('')
  const [postDescription, setPostDescription] = useState('')

  useEffect(() => {
    if (postType === 'post') {
      setPostTitle('Arraste a imagem aqui')
      setPostDescription('Serão aceitas até 10 imagens')
    } else {
      setPostTitle('Arraste o vídeo aqui')
      setPostDescription('Será aceito apenas 1 vídeo de até 5 minutos')
    }
  }, [postType])

  const [selectedProportion, setSelectedProportion] = useState('1:1')
  const [proportionHeight, setProportionHeight] = useState(100)

  useEffect(() => {
    switch (selectedProportion) {
      case '1:1':
        setProportionHeight(124.4)
        break;
      case '3:4':
        setProportionHeight(100)
        break;
      case '4:3':
        setProportionHeight(75)
        break;
      case '9:16':
        setProportionHeight(0)
        break;
      case '16:9':
        setProportionHeight(177)
        break;
      default:
        break;
    }
  }, [selectedProportion])

  const createImage = (url: string) =>
    new Promise((resolve, reject) => {
      const image = new Image();
      image.addEventListener('load', () => resolve(image));
      image.addEventListener('error', (error) => reject(error));
      image.setAttribute('crossOrigin', 'anonymous'); // needed to avoid CORS issues
      image.src = url;
    });

  const getCroppedImg = async (imageSrc: File, fileName: any) => {
    const imageBitmap: ImageBitmap = await createImageBitmap(imageSrc); // Blob file
    const { width, height } = imageBitmap;
    const newDim = adjustDimensions(width, height);
    const image = await createImage(URL.createObjectURL(imageSrc));
    const canvas = document.createElement('canvas');
    canvas.width = newDim.newWidth;
    canvas.height = newDim.newHeight;
    const ctx: any = canvas.getContext('2d');

    ctx.drawImage(
      image,
      newDim.offsetX,
      newDim.offsetY,
      newDim.newWidth,
      newDim.newHeight,
      0,
      0,
      newDim.newWidth,
      newDim.newHeight
    );

    return new Promise((resolve) => {
      canvas.toBlob((blob: any) => {
        if (!blob) {
          // handle error
          console.error('Canvas is empty');
          return;
        }
        blob.name = fileName;
        resolve(blob);
      }, 'image/jpeg');
    });
  }

  return (
    <Dialog
      open={open}
      onClose={() => onClose(false)}
      disableEnforceFocus={true}
      maxWidth={false}
      PaperProps={{ sx: { borderRadius: "32px" } }}
      style={{
        display: 'flex',
        backgroundColor: 'rgba(27, 27, 27, 0.85)',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {step === 0 && (
        <Container>
          <Header>
            <HeaderText>Compartilhar</HeaderText>
            <CloseModal onClick={() => onClose(false)}>
              <Close />
            </CloseModal>
          </Header>
          <SelectorContainer>
            <SelectorOption selected={postType === 'post'} onClick={() => setPostType('post')}>
              <SelectorText selected={postType === 'post'}>Post</SelectorText>
            </SelectorOption>
            <SelectorOption selected={postType === 'snipz'} onClick={() => setPostType('snipz')}>
              <SelectorText selected={postType === 'snipz'}>Snipz</SelectorText>
            </SelectorOption>
          </SelectorContainer>
          <FileUploader
            multiple={true}
            handleChange={handleFiles}
            name="file"
            types={postType === 'post' ? imageFileTypes : videoFileTypes}
            onClick={() => { }}
          >
            <InputContainer>
              <InputTopContainer>
                <ImageWrapper>{postType === 'post' ? <ImageIcon /> : <SnipzIcon />}</ImageWrapper>
                <InputTitle>{postTitle}</InputTitle>
                <InputDescription>
                  {postDescription}
                </InputDescription>
              </InputTopContainer>
              <InputMiddleContainer>
                <InputMiddleLine />
                <InputMiddleText>ou</InputMiddleText>
                <InputMiddleLine />
              </InputMiddleContainer>
              <InputBottomContainer>
                <Button
                  height={44}
                  text="Selecionar arquivo do computador"
                  theme="dark"
                  onClick={() => { }}
                  width={270}
                />
              </InputBottomContainer>
            </InputContainer>
          </FileUploader>
        </Container>
      )}
      {step === 1 && (
        <Container>
          <Header2>
            <HeaderIcon onClick={() => handleBack()}>
              <ArrowBack />
            </HeaderIcon>
            <HeaderText>Novo post</HeaderText>
            <FollowText onClick={() => handlePublish()}>Publicar</FollowText>
          </Header2>
          <ContentContainer>
            <ContentTopContainer>
              <ImageContainer>
                {!hasVideo ?
                  <>
                    <div style={{
                      borderTopLeftRadius: 24,
                      borderTopRightRadius: 24,
                      width: '100%',
                      height: proportionHeight,
                      position: 'relative',
                      marginBottom: -proportionHeight,
                      backgroundColor: 'rgba(27, 27, 27, 0.8)'
                    }}
                    />
                    <img
                      src={URL.createObjectURL(files[selectedPostIndex])}
                      alt="media"
                      style={{ width: '320px', height: '568.8px', objectFit: 'contain', borderRadius: 24, backgroundColor: 'black' }}
                    />
                    <div style={{
                      borderBottomLeftRadius: 24,
                      borderBottomRightRadius: 24,
                      width: '100%',
                      height: proportionHeight,
                      position: 'relative',
                      marginTop: -proportionHeight,
                      backgroundColor: 'rgba(27, 27, 27, 0.8)'
                    }}
                    />
                  </>
                  :
                  <SnipzPlayer modal={false} isFeed={false} local={true} src={URL.createObjectURL(files[selectedPostIndex])} />
                }
              </ImageContainer>
              <InfosContainer>
                <InfosInnerContainer>
                  <User icon={user?.avatarUrl as any} username={user?.username as any} />
                  <EmoteIconWrapper>
                    <EmoteIcon />
                  </EmoteIconWrapper>
                  <DescriptionInput
                    maxLength={2000}
                    value={descriptions[selectedPostIndex]}
                    onChange={(e) => handleDescriptionChange(selectedPostIndex, e.target.value)}
                    placeholder="Adicione uma legenda"
                    rows={4}

                  />
                  <LetterCounter>{descriptions[selectedPostIndex].length}/2000</LetterCounter>
                </InfosInnerContainer>
                <InfosInnerContainer>
                  <TagsTitle>Adicione as tags para essa postagem</TagsTitle>
                  <InputLogin
                    value={tagInputValue}
                    icon={<SearchIcon color={'rgba(153, 153, 153, 1)'} />}
                    handler={(e) => handleTags(e)}
                    placeholder="Adicionar tags"
                  />
                  <TagsContainer>
                    {tags && tags.map((tag, index) =>
                      <Tag onClick={
                        () => {
                          const newTags = tags.filter((_, i) => i !== index);
                          setTags(newTags);
                        }
                      } key={index}>{tag}<DeleteTag /></Tag>
                    )}
                  </TagsContainer>
                </InfosInnerContainer>
                {!hasVideo ? (
                  <InfosInnerContainer>
                    <TagsTitle>Proporção das imagens</TagsTitle>
                    <ProportionsContainer>
                      <ProportionButton
                        selected={selectedProportion === '1:1'}
                        onClick={() => setSelectedProportion('1:1')}
                      >1:1</ProportionButton>
                      <ProportionButton
                        selected={selectedProportion === '3:4'}
                        onClick={() => setSelectedProportion('3:4')}
                      >3:4</ProportionButton>
                      <ProportionButton
                        selected={selectedProportion === '4:3'}
                        onClick={() => setSelectedProportion('4:3')}
                      >4:3</ProportionButton>
                      <ProportionButton
                        selected={selectedProportion === '9:16'}
                        onClick={() => setSelectedProportion('9:16')}
                      >9:16</ProportionButton>
                      <ProportionButton
                        selected={selectedProportion === '16:9'}
                        onClick={() => setSelectedProportion('16:9')}
                      >16:9</ProportionButton>
                    </ProportionsContainer>
                    <ProportionInfo>Será aplicada em todas as imagens</ProportionInfo>
                  </InfosInnerContainer>
                ) : null}
              </InfosContainer>
            </ContentTopContainer>
            {!hasVideo &&
              <ContentBottomContainer>
                {files && files.map((file: any, index) =>
                  <ImageButton key={index}>
                    {(index !== 0 || files.length > 1) &&
                      <DeleteButtonWrapper onClick={() => handleDeleteImage(index)}>
                        <DeleteIcon />
                      </DeleteButtonWrapper>
                    }
                    <img
                      src={URL.createObjectURL(file)}
                      style={{ cursor: 'pointer', width: '100%', height: '100%', objectFit: 'cover' }}
                      onClick={() => { setSelectedPostIndex(index) }}
                    />
                  </ImageButton>
                )}
                <FileUploader
                  multiple={true}
                  handleChange={handleFiles}
                  name="file"
                  types={postType === 'post' ? imageFileTypes : videoFileTypes}
                >
                  <AddImageButton>
                    <PlusIcon />
                    Adicionar mídia
                  </AddImageButton>
                </FileUploader>
              </ContentBottomContainer>
            }
          </ContentContainer>
        </Container>
      )}
    </Dialog>
  );
}

function DeleteIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <g
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.333"
        clipPath="url(#clip0_1075_13307)"
      >
        <path
          fill="#F33333"
          stroke="#F33333"
          d="M8 14.667A6.667 6.667 0 108 1.333a6.667 6.667 0 000 13.334z"
        ></path>
        <path stroke="#fff" d="M10 6l-4 4M6 6l4 4"></path>
      </g>
      <defs>
        <clipPath id="clip0_1075_13307">
          <path fill="#fff" d="M0 0H16V16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

function DeleteTag() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#fff"
        d="M8 1.333A6.66 6.66 0 001.333 8 6.66 6.66 0 008 14.667 6.66 6.66 0 0014.667 8 6.66 6.66 0 008 1.333zm3.333 9.06l-.94.94L8 8.94l-2.393 2.393-.94-.94L7.06 8 4.667 5.607l.94-.94L8 7.06l2.393-2.393.94.94L8.94 8l2.393 2.393z"
        opacity="0.7"
      ></path>
    </svg>
  );
}

function ImageIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="88"
      height="89"
      fill="none"
      viewBox="0 0 88 89"
    >
      <path
        stroke="#4D4D4D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="7.333"
        d="M69.667 11.499H18.333A7.333 7.333 0 0011 18.832v51.333a7.333 7.333 0 007.333 7.334h51.334A7.333 7.333 0 0077 70.165V18.832a7.333 7.333 0 00-7.333-7.333z"
      ></path>
      <path
        stroke="#4D4D4D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="7.333"
        d="M31.167 37.165a5.5 5.5 0 100-11 5.5 5.5 0 000 11zM77 55.498L58.667 37.165 18.333 77.498"
      ></path>
    </svg>
  );
}

function SnipzIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="88"
      height="88"
      fill="none"
      viewBox="0 0 88 88"
    >
      <g
        stroke="#4D4D4D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="7.333"
        clipPath="url(#clip0_1806_16019)"
      >
        <path d="M82.647 23.539a10.193 10.193 0 00-7.113-7.334c-6.307-1.54-31.533-1.54-31.533-1.54s-25.227 0-31.534 1.687a10.193 10.193 0 00-7.113 7.334 106.333 106.333 0 00-1.687 19.396 106.332 106.332 0 001.687 19.544 10.193 10.193 0 007.113 7.04c6.307 1.686 31.534 1.686 31.534 1.686s25.226 0 31.533-1.687a10.193 10.193 0 007.113-7.333 106.334 106.334 0 001.687-19.25 106.326 106.326 0 00-1.687-19.543z"></path>
        <path d="M35.75 55.072l21.084-11.99-21.084-11.99v23.98z"></path>
      </g>
      <defs>
        <clipPath id="clip0_1806_16019">
          <path fill="#fff" d="M0 0H88V88H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

function PlusIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      fill="none"
      viewBox="0 0 16 17"
    >
      <g
        stroke="#6E30E8"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.333"
        clipPath="url(#clip0_1082_14199)"
      >
        <path d="M8 15.638A6.667 6.667 0 108 2.305a6.667 6.667 0 000 13.333zM8 6.305v5.333M5.333 8.972h5.334"></path>
      </g>
      <defs>
        <clipPath id="clip0_1082_14199">
          <path
            fill="#fff"
            d="M0 0H16V16H0z"
            transform="translate(0 .972)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
}

function Close() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      fill="none"
      viewBox="0 0 17 17"
    >
      <path
        fill="#999"
        d="M8.667 6.89L14.889.666l1.778 1.777-6.223 6.223 6.223 6.222-1.778 1.778-6.222-6.223-6.223 6.223-1.777-1.778 6.222-6.222L.667 2.444 2.444.667l6.223 6.222z"
      ></path>
    </svg>
  );
}